import { render, staticRenderFns } from "./OtpTwoFactorAuthenticator.vue?vue&type=template&id=42bb6386&scoped=true&"
import script from "./OtpTwoFactorAuthenticator.vue?vue&type=script&lang=js&"
export * from "./OtpTwoFactorAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb6386",
  null
  
)

export default component.exports